import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';

export default function Wait_Render(props) {
  const { setNodeData, nodeData } = props;
  const [wait, setWait] = useState(nodeData.type === "wait"? nodeData.wait: 0);
  setNodeData({
    type: "wait",
    wait: wait
  })
  const handleChangeWait = (event) => {
    const regex = /^[0-9\b]+$/;
    if (event.target.value === "" || regex.test(event.target.value)){
        setWait(event.target.value)
        setNodeData({
            type: "wait",
            wait: event.target.value
        })
    }
  }
  return(<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
    <TextField
      id="outlined-required"
      label="Wait"
      value={wait}
      type="number"
      name="robot_actions"
      style={{width: "100%"}}
      onChange={handleChangeWait}
    >
    </TextField>
  </Grid>
  )
}